import * as React from "react";
import ScrollBar from "react-perfect-scrollbar";
import { connect } from "react-redux";
import { ScrollOptions } from "../../constants/ScrollOptions";
import { IdStyles } from "../../less/IdStyles";
import { selectCoopNoticeEvents } from "../../selectors/selectCoopInfo";
import { utilNumber } from "../../utils/utilNumber";
import { List } from "../generic/list/List";
import { CoopMessageNotice } from "./CoopMessageNotice";
export var _CoopEventNotices = function (_a) {
    var coopEventNotices = _a.coopEventNotices;
    return (React.createElement("div", { className: IdStyles.CoopNoticeContainer + " flex flex--centered" },
        React.createElement(ScrollBar, { component: "div", options: ScrollOptions, className: "w100" },
            React.createElement(List, { items: coopEventNotices, renderItem: renderCoopMessage }))));
};
var renderCoopMessage = function (coopMessageItem) {
    var componentKey = getUniqueKeyFromMessageParam(coopMessageItem);
    return React.createElement(CoopMessageNotice, { coopMessageItem: coopMessageItem, key: componentKey });
};
var getUniqueKeyFromMessageParam = function (coopMessageItem) {
    var creationTime = utilNumber.format(coopMessageItem.creationTime);
    var messageType = utilNumber.format(coopMessageItem.messageType);
    return creationTime + "-" + messageType;
};
var mapState = function (state) {
    return {
        coopEventNotices: selectCoopNoticeEvents(state),
    };
};
export var CoopEventNotices = connect(mapState)(_CoopEventNotices);



//////////////////
// WEBPACK FOOTER
// ./src/features/cooperative/CoopEventNotices.tsx
// module id = 2616
// module chunks = 3